<template>
    <!-- Header -->
    <div class="row wrapper border-bottom white-bg page-heading py-2">
        <div class="col-lg-6 d-flex align-items-center">
            <h2 class="mb-0">Safety Report Dashboard</h2>
        </div>

        <div class="col-lg-6 d-flex justify-content-end align-items-center">
            <h2 class="text-primary back-btn mb-0" @click="goBack">
                Back
            </h2>
        </div>
    </div>

    <!-- Content -->
    <div class="wrapper wrapper-content px-0" >
        <!-- History -->
        <div class="row mx-0 mb-2">
            <div class="col-md-12 pl-1 pr-0">
                <historytab :historyarray="historykeys" @gotohistorylevel="gotohistorylevel" @exporttopdf="exporttopdf"
          @exporttoexcell="exporttoexcell" />
            </div>
        </div>

        <!-- KPI Tiles -->
        <div class="kpi-row px-1">

            <!-- ENROLLED -->
            <div class="mr-1">
                <div class="dash-widget cursor-pointer" @click="openSubjectModal('enrolled')">
                    <div class="tile-content">
                        <div class="tile-left">
                            <h4>Enrolled</h4>

                            <!-- <h1 class="font-bold">
                                    {{ tilevalues.totalSubjects }}
                                </h1> -->

                            <small>
                                {{ tilevalues.totalCohorts }} Cohorts
                            </small>
                        </div>

                        <div class="tile-right">
                            <span class="tile-count">
                                {{ tilevalues.totalSubjects }}
                            </span>
                        </div>
                    </div>

                </div>
            </div>

            <!-- AEs -->
            <div class="mr-1">
                <div class="dash-widget cursor-pointer" @click="showtablepopup('ALL', 'All Adverse Events')">

                    <div class="tile-content">
                        <div class="tile-left">

                            <h4>AEs Reported</h4>

                            <!-- <h1 class="font-bold">
                                    {{ tilevalues.totalAEs }}
                                </h1> -->

                            <small>
                                {{ tilevalues.subjectsWithAe }}
                                Subjects
                                ({{ tilevalues.subjectsWithAePercentage }}%)
                            </small>

                        </div>

                        <div class="tile-right">
                            <span class="tile-count">
                                {{ tilevalues.totalAEs }}
                            </span>
                        </div>
                    </div>

                </div>
            </div>

            <!-- SAEs -->
            <div class="mr-1">
                <div class="dash-widget cursor-pointer" @click="showtablepopup('SAE', 'Serious Adverse Events')">

                    <div class="tile-content">
                        <div class="tile-left">

                            <h4>SAEs</h4>

                            <!-- <h1 class="font-bold">
                                    {{ tilevalues.saEs }}
                                </h1> -->

                            <small>
                                {{ tilevalues.possiblyRelatedSaes }}
                                Possibly related
                            </small>

                        </div>

                        <div class="tile-right">
                            <span class="tile-count">
                                {{ tilevalues.saEs }}
                            </span>
                        </div>
                    </div>

                </div>
            </div>

            <!-- SUSAR -->
            <div class="mr-1">
                <div class="dash-widget cursor-pointer" @click="showtablepopup('SUSAR', 'SUSAR Events')">

                    <div class="tile-content">
                        <div class="tile-left">

                            <h4>SUSAR</h4>

                            <!-- <h1 class="font-bold">
                                    {{ tilevalues.susaRs }}
                                </h1> -->

                            <small>
                                <!-- Unexpected reactions -->
                            </small>

                        </div>

                        <div class="tile-right">
                            <span class="tile-count">
                                {{ tilevalues.susaRs }}
                            </span>
                        </div>
                    </div>

                </div>
            </div>

            <!-- WITHDRAWALS -->
            <div class="kpi-col">
                <div class="dash-widget cursor-pointer" @click="openSubjectModal('withdrawn')">

                    <div class="tile-content">
                        <div class="tile-left">

                            <h4>Withdrawals</h4>

                            <!-- <h1 class="font-bold">
                                    {{ tilevalues.fatalEvents }}
                                </h1> -->

                            <small>
                                of {{ tilevalues.totalSubjects }} enrolled
                            </small>

                        </div>

                        <div class="tile-right">
                            <span class="tile-count">
                                {{ tilevalues.withdrawnPatients }}
                            </span>
                        </div>
                    </div>

                </div>
            </div>

        </div>
                 <!-- Search Filters -->
       <div class="row mt-2 mx-0">
            <div class="col-12 pl-1 pr-0">
                <div class="ibox-content">
                    <div class="row">

                        <!-- Site Code -->
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <label class="mb-1">Site Code</label>
                            <select v-model="searchFilters.siteCode" class="form-control">
                                <option value="">All</option>
                                <option v-for="site in allSites" :key="site.siteCode" :value="site.siteCode">
                                    {{ site.siteCode }}
                                </option>
                            </select>
                        </div>

                        <!-- Subject -->
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <label class="mb-1">Subject</label>
                            <input v-model="searchFilters.subject" type="text" class="form-control" placeholder="Enter subject code" />
                        </div>

                        <!-- AE Term -->
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <label class="mb-1">AE Term</label>
                            <input v-model="searchFilters.aeTerm" type="text" class="form-control" placeholder="Enter AE term" />
                        </div>

                      <!-- Severity -->
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <label class="mb-1">Severity</label>

                            <select v-model="searchFilters.severity" class="form-control">
                                <option v-for="item in severityOptions" :key="item" :value="item">
                                    {{ item }}
                                </option>
                            </select>
                        </div>
                         <!-- CTCAE Grade -->
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <label class="mb-1">CTCAE Grade</label>

                            <select v-model="searchFilters.ctcaeGrade" class="form-control">
                                <option v-for="item in ctcaeGradeOptions" :key="item" :value="item">
                                    {{ item }}
                                </option>
                            </select>
                        </div>

                      <!-- Outcome -->
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <label class="mb-1">Outcome</label>

                            <select v-model="searchFilters.outcome" class="form-control">
                                <option v-for="item in outcomeOptions" :key="item" :value="item">
                                    {{ item }}
                                </option>
                            </select>
                        </div>

                       

                        <!-- Search Button -->
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2 d-flex align-items-end">
                            <span type="button" class="save_btn w-100 text-center" @click="applySearchFilters">
                                {{ $t("navigations.search") }}
                            </span>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- Charts -->
        <div class="row mt-2 mx-0" ref="captureArea1">
            <!-- Left Chart -->
            <div class="col-lg-6 pr-0 pl-1">
                <div class="chart-content">
                   <barchart :loader="loader" :data="aetimeline" :availableColumns="formattedChartColumns"
                        @exporttoexcell="handleExport" @opendrillpopup="openDataOverview" :fromPage="'safetydashboard'"
                        yAxisKey="count" xAxisKey="grade" chartlabel="AE Overview"
                        @drilldowncurrentchart="drilldowncurrentchartforbar" />
                </div>
            </div>
            <!-- Right Chart -->
            <div class="col-lg-6 pr-0 pl-1">
                <donutchart :loader="loader" :dataArray="aetimeline" groupField="causality"
                    chartLabel="AEs by Causality"
                     @opendrillpopup="openDataOverview"
                    @drilldowncurrentchart="drilldowncurrentchartforbar" />

            </div>
        </div>
        <!-- Horizontal Percentage Bar -->
        <div class="row mt-2 mx-0" ref="captureArea2">
            <div class="col-12 pl-1 pr-0">
               <HorizontalPercentageBar 
                    :key="'hpb-'+historykeys.length+'-'+aetimeline.length"
                    :loader="loader" 
                    :dataArray="[...aetimeline]"
                    groupField="term"
                    chartLabel="Most Frequent AEs (by Term)"
                   @opendrillpopup="openDataOverview"
                    @drilldowncurrentchart="drilldowncurrentchartforbar"
                />
            </div>
        </div>

        <!-- SAE Summary -->
        <div class="row mt-2 mx-0">
            <div class="col-lg-3 px-1">
                <div class="ibox-title style_2 d-flex justify-content-between">
                    <h5>Serious adverse events (SAE)</h5>
                </div>

                <div class="sae-summary-minimal ibox-content">
                    <table class="table sae-summary-table mb-0">
                        <tbody>
                            <tr v-for="(item, index) in termCounts" :key="index">
                                <td class="sae-term-col">
                                    <div class="sae-row">
                                        <span class="sae-label">{{ item.term }}</span>
                                        <span class="sae-dots"></span>
                                        <span class="sae-grade-text">{{ item.count }}</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-lg-3 px-1">
                <div class="ibox-title style_2 d-flex justify-content-between">
                    <h5>SAE Outcome</h5>
                </div>

                <div class="sae-summary-minimal ibox-content">
                    <table class="table sae-summary-table mb-0">
                        <tbody>
                            <tr v-for="(item, index) in outcomeCounts" :key="index">
                                <td class="sae-term-col">
                                    <div class="sae-row">
                                        <span class="sae-label">{{ item.outcome }}</span>
                                        <span class="sae-dots"></span>
                                        <span class="sae-grade-text">{{ item.count }}</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- AEs By Cohort -->
            <div class="col-lg-6 px-1">
                <!-- Title -->
                <div class="ibox-title style_2 d-flex justify-content-between">
                    <h5 class="">AEs by Cohort</h5>
                </div>

                <!-- Content -->
                <div class="ibox-content sae-summary-minimal">
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Cohort Code</th>
                                    <th>Cohort Name</th>
                                    <th>No. of Subjects</th>
                                    <th>AE Count</th>
                                    <th>CTCAE Grade ≥ 3</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr v-for="(item, index) in cohortSummary" :key="index">
                                    <td> {{ item.cohortCode }} </td>
                                    <td> {{ item.cohortName }} </td>
                                    <td> {{ item.subjects }} </td>
                                    <td> {{ item.aeCount }}  </td>
                                    <td> {{ item.grade3Plus }} </td>
                                </tr>

                                <tr v-if="!loader && cohortSummary.length === 0">
                                    <td colspan="4" class="text-center">
                                        No records found
                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </div>

        <!-- AE Timeline Table -->
        <div class="row mt-2 mx-0">
            <div class="col-lg-12 pr-0 pl-1">
                <div class="ibox-title style_2 d-flex justify-content-between">
                    <h5> AE Summary </h5>
                    <!-- Export Icon -->
                    <span class="position-relative cursor-pointer me-2 export-icon-wrapper" @click="exportAeTimeline">
                        <img width="17" height="17" src="../../assets/img/upload.png" alt="Export" />

                        <div class="tool-tip">
                            Export
                        </div>
                    </span>

                </div>

                <div class="ibox-content">
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Subject Id</th>
                                    <th>Site Code </th>
                                    <th>Cohort Code</th>
                                    <th>Cohort Name</th>
                                    <th>AE Term</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Duration</th>
                                    <th>Severity</th>
                                    <th>CACTE Grade</th>
                                    <th>Causality</th>
                                    <th>Outcome</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in paginatedAeTimeline" :key="item.id">
                                    <td>{{ item.subjectId }}</td>
                                    <td>{{ item.siteCode }}</td>
                                    <td>{{ item.cohortCode }}</td>
                                    <td>{{ item.cohortName }}</td>
                                    <td>{{ item.term }}</td>
                                    <td>{{ filter(item.startDate) }}</td>
                                    <td>{{ filter(item.endDate) }}</td>
                                    <td>{{ item.duration }}</td>
                                    <td>{{ item.severity }}</td>
                                    <td>{{ item.grade }}</td>
                                    <td>{{ item.causality }}</td>
                                    <td>{{ item.outcome }}</td>
                                </tr>

                                <tr v-if="!loader && paginatedAeTimeline.length === 0">
                                    <td colspan="9" class="text-center">
                                        No records found
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Pagination -->

                    <div class="row mx-0 mt-2" v-if="aeTimelineTotalPages > 1">

                        <div class="col-lg-12 mx-0 px-0">

                            <div class="dataTables_paginate paging_simple_numbers pagination float-right">

                                <div class="col-lg-12 d-flex justify-content-lg-end px-0">

                                    <v-pagination v-model="aeTimelineCurrentPage" :pages="aeTimelineTotalPages"
                                        :range-size="1" active-color="#618bd7"
                                        @update:modelValue="loadAeTimelinePage" />

                                </div>

                            </div>

                        </div>

                    </div>

                </div>


            </div>

        </div>

    </div>
    <!-- export popup -->
    <exportpopup v-if="showExportModal" @closeModal="showExportModal = false" />
    <!-- export popup -->


    <!-- AE Table Modal -->
    <aetablemodel v-if="openaetable" :aetype="aetype" :tableName="aetabletitle" :tableLoading="aetableloading"
        :tableData="aetableresult" @close="closetablepopup" />
    <!-- AE Table Modal -->


    <!-- subject details modal  -->
    <subjectdetailsmodal v-if="showSubjectModal" :key="`${studyId}-${subjectFilter}`" :studyId="studyId" :toFilter="subjectFilter"
        @close="showSubjectModal = false" />
    <!-- subject details modal  -->


    <chartdrill
  v-if="drillpopup"
  :key="`drill-${Date.now()}`"
  fileheadding="Adverse events summary"
  :drilldata="drilldata"
  :templateId="templateId"
  fromPage="adverseEventsPop"
  @closepopup="onclosed()"
/>
</template>

<script src="./SafetyDashboard.js"></script>

<style scoped>
.sae-row {
    display: flex;
    align-items: center;
    width: 100%;
}

.sae-label {
    font-size: 12px;
    font-weight: 500;
    color: #1f2a44;
    white-space: nowrap;
    text-transform: uppercase;
}

.sae-dots {
    flex: 1;
    border-bottom: 1.5px dotted #ccc;
    margin: 0 6px;
    margin-bottom: 2px;
    border-radius: 0;
}

.page-heading {
    padding: 18px 20px;
}

/* Back */

.back-btn {
    cursor: pointer;
    font-size: 18px;
}

.stat-card-white {
    border-radius: 1px !important;
}

/* KPI Row */

.kpi-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}

/* KPI Column */

.kpi-col {
    width: 100%;
    flex: 0 0 20%;
}



/* Dashboard Tile */

.dash-widget {
    padding: 12px;
    background: #ffffff;
    border-left: 6px solid #ff3c3cab !important;
    border-radius: 4px;
}

.dash-widget:hover {
    transform: translateY(-2px);
}

/* Tile Layout */

.tile-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
}

.tile-left {
    width: calc(100% - 70px);
}

.tile-right {
    min-width: 70px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.tile-count {
    font-size: 34px;
    font-weight: 600;
    color: #676a6c;
    line-height: 1;
}

/* Tile Text */

.dash-widget h4 {
    font-size: 12px;
    font-weight: 600;
    color: #1f2a44;
    margin-bottom: 6px;
    line-height: 16px;
}


.dash-widget small {
    color: #8c97a8;
    font-size: 11px;
    line-height: 15px;
    display: block;
}

/* Tile Image */

.dash-widget img {
    width: 42px;
    height: 42px;
    object-fit: contain;
}

/* Chart Boxes */

.ibox-body {
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e7eaec;
    overflow: hidden;
}

.ibox-title {
    padding: 8px 15px 4px 15px;
    min-height: 34px;
}

.ibox-title h5 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #1f2a44;
}

.ibox-content {
    padding: 15px;
}

.chart-content {
    height: 500px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.chart-content {
    height: 500px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* SAE Summary */

.sae-summary-card {
    background: #fff;
    border-radius: 6px;
    padding: 18px;
    border: 1px solid #e7eaec;
}

.sae-summary-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    flex-wrap: wrap;
    gap: 15px;
}

.sae-summary-header h4 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
}

.summary-count {
    color: #dc3545;
}

.sae-total-box {
    text-align: right;
}

.sae-total-value {
    font-size: 30px;
    font-weight: 700;
    line-height: 1;
    color: #dc3545;
}

.sae-total-label {
    font-size: 13px;
    font-weight: 600;
    color: #1f2a44;
}

/* SAE Summary */

.sae-summary-simple {
    background: #ffffff;
    border: 1px solid #e7eaec;
    border-radius: 6px;
    padding: 18px 20px;
}

.sae-summary-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 14px;
    margin-bottom: 10px;
    border-bottom: 1px solid #eef1f5;
}

.sae-summary-top h4 {
    font-size: 16px;
    font-weight: 600;
    color: #1f2a44;
}

.summary-count {
    color: #dc3545;
}

.sae-summary-total {
    font-size: 14px;
    color: #676a6c;
    font-weight: 500;
}

.sae-total-number {
    font-size: 20px;
    font-weight: 700;
    color: #dc3545;
    margin-right: 4px;
}


/* SAE Summary */

.sae-summary-minimal {
    height: 300px;
    overflow-y: auto;
}

.sae-summary-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.sae-summary-heading h4 {
    font-size: 14px;
    font-weight: 600;
    color: #1f2a44;
    margin: 0;
}

.sae-summary-count {
    font-size: 15px;
    font-weight: 700;
    color: #dc3545;
    white-space: nowrap;
}

.sae-summary-count span {
    font-size: 11px;
    font-weight: 500;
    color: #7d8896;
    margin-left: 3px;
}

.sae-summary-table {
    width: 100%;
}

.sae-summary-table tr td {
    border: none !important;
    padding: 5px 0;
    vertical-align: middle;
}

.sae-term-col {
    font-size: 12px;
    font-weight: 500;
    color: #1f2a44;
    padding-right: 8px !important;
}

.sae-grade-text {
    color: #dc3545;
    margin-left: 3px;
    font-weight: 600;
}

.sae-count-col {
    width: 35px;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    color: #1f2a44;
}

.sae-outcome-col {
    width: 110px;
    text-align: left;
    font-size: 11px;
    color: #7d8896;
    white-space: nowrap;
}

/* Responsive */

@media (max-width: 1200px) {

    .kpi-row {
        flex-wrap: wrap;
    }

    .kpi-col {
        width: 33.33%;
        flex: 0 0 33.33%;
        margin-bottom: 10px;
    }
}

@media (max-width: 768px) {

    .kpi-col {
        width: 50%;
        flex: 0 0 50%;
    }

    .dash-widget h1 {
        font-size: 24px;
    }
}

@media (max-width: 576px) {

    .kpi-col {
        width: 100%;
        flex: 0 0 100%;
    }
}
</style>
